import type { SurfaceNavTab } from "./surface-capabilities";

export interface WeeklyWalkthrough {
  id: string;
  title: string;
  ctaLabel: string;
  targetRoute: string;
  targetAction: string;
  outcome: string;
  prerequisites: string;
  targetTab: SurfaceNavTab;
  eventName: string;
  eventDetail?: Record<string, string>;
  dispatchDelayMs?: number;
  steps: string[];
}

export const WEEKLY_WALKTHROUGH_EVENTS = {
  open: "fintheon:open-weekly-walkthrough",
  fileRoomUpdates: "fintheon:open-file-room-updates",
  fileRoomSection: "fintheon:file-room-open-section",
  scoutsFocusCreate: "fintheon:scouts-focus-create",
  equitiesSentimentFocus: "fintheon:equities-sentiment-focus",
  caoChat: "fintheon:open-cao-chat",
  narrativeflowWorkspace: "fintheon:jump-to-narrativeflow",
  performanceHeatmaps: "fintheon:performance-heatmaps-focus",
  performanceOpenView: "fintheon:performance-open-view",
  riskflowFocus: "fintheon:riskflow-focus",
  warRoom: "fintheon:open-war-room",
  tradingBrowserOpen: "fintheon:trading-browser-open",
  settingsTab: "fintheon:settings-open-tab",
  versionInfo: "fintheon:version-info-focus",
} as const;
